import { ref } from 'vue';
import router from '@/router/index'
const API_URL = process.env.VUE_APP_ROOT_API;
import { clubUUID, userUUID, loggedIn } from '@/shared/state';
import { useUser } from "@/composables/auth/useUser";

import { useClub } from '@/composables/club/useClub';



export function useLogin() {
    const { initialValuesClub } = useClub();
    const { hasAdminRole, hasSuperAdminRole } = useUser();
    const error = ref<string | null>(null);
    const accessToken = ref<string | null>(null);
    const login = async (body: any) => {
        error.value = null;

        try {
            // Example API call for login
            const response = await fetch(`${API_URL}signin`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: body.email,
                    password: body.password
                }),
            });

            if (!response.ok) {
                throw new Error('Login failed');
            }

            const data = await response.json();


            if (response.ok) {

                localStorage.setItem('user', JSON.stringify(data));
                localStorage.setItem('authToken', data?.accessToken);
                userUUID.value = data?.data?.uuid || '';
                localStorage.setItem('selectedUserUUID', userUUID.value || '');
                loggedIn.value = true
                router.push({ name: 'users', params: { userUUID: userUUID.value } }).then(() => {
                    location.reload();
                });


            } else {
                throw new Error('Token not found in response');
            }
            // Handle successful login (e.g., store token, redirect)
        } catch (err: any) {
            error.value = err.message;
        }
    };
    const logout = async () => {
        error.value = null;
        try {
            loggedIn.value = false
            localStorage.removeItem('user');
            localStorage.removeItem('authToken');
            localStorage.removeItem('selectedUserUUID');
            localStorage.removeItem('selectedClub');
            userUUID.value = null;
            clubUUID.value = null;
            initialValuesClub(null)
            router.push({ name: 'login' })

            // Handle successful login (e.g., store token, redirect)
        } catch (err: any) {
            error.value = err.message;
        }
    };

    return {
        login,
        logout,

        error,
    };
}
